<script>
  import { ignore, makeWebsiteRequest } from "../../../Common/tools";
  import { onMount } from "svelte";
  import {External, M} from "../../../external";

  export let data;
  export let valid;
  export let onChange = ignore;

  let lists = [];
  if (!data) data = {};
  if (!data.settings) data.settings = data.settings || [];

  const onListsSelected = (lists) => {
    data.settings = lists;
    data.name = data.settings.map((setting) => setting.value).join(", ");
    valid = data.settings && data.settings.length > 0;
    onChange();
  };

  async function load() {
    let request = {
        page: 0,
        withStats: false
      },
      filters = {};

    if (Object.keys(filters).length > 0) {
      request.filters = JSON.stringify(filters);
    }

    let response = await makeWebsiteRequest({
      action: "getMarketingLists",
      data: request
    });

    lists = response.data || [];
    valid = data.settings.length > 0;
  }

  let click = () => {
    let selectedLists = data.settings.map((setting) => External.getById(lists, setting.key, false)).filter((list) => !!list);

    External.UITools.selectMarketingLists(lists, selectedLists, (newLists) => {
      let selected = newLists.map((list) => {
        return { key: list.id + "", value: list.name + "" };
      });
      onListsSelected(selected);
    });
  };

  onMount(load);
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">{M.TRIGGER_LIST_ADD}</h4>
  <div class="multiple-items-picker mt-25 mb-5">
    <ul class="groups category-groups mb-15">
      <li>
        <a on:click={click} rel="action" data-action="editProductCategories" class="middle-button gray">{M.SELECT_YOUR_LISTS}</a>
      </li>
      <li>{data.settings.length} {data.settings.length === 1 ? M.LIST : M.LISTS} {M.SELECTED}</li>
    </ul>
  </div>
  <div class="col20 f-left gray-section product-select-wrapper mb-5 none">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">Applied to everyone</h4>
      <a class="text-link blue-text" data-role="changeTextStyles">Change</a>
    </div>
  </div>
</div>
